import React from 'react';
import store from "./app/store";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import "./assets/fonts/Poppins/Poppins-Light.ttf"
import "./assets/fonts/Poppins/Poppins-Bold.ttf"
import "./assets/fonts/Poppins/Poppins-Thin.ttf"
import "./assets/fonts/Poppins/Poppins-SemiBold.ttf"
import "./assets/fonts/Poppins/Poppins-Regular.ttf"
import "./assets/fonts/Poppins/Poppins-Medium.ttf"
import 'react-phone-number-input/style.css'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HashRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
